// Types
import { EquipmentUnitDataVSICrusher } from '../../../../../types/crusher';
import { EdgeDeviceOperationalStatus } from '../../../../../types/global';

export enum MaintenanceType {
  comboUnit = 'comboUnit',
  cone = 'cone',
  ifm = 'ifm',
  maintenance = 'maintenance',
  plc = 'plc',
  sensorScaling = 'sensorScaling',
  setPoint = 'setPoint',
  setup = 'setup',
}

export interface MaintenanceProps {
  className?: string;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  onClose: () => void;
  isOpen: boolean;
  testId?: string;
  unitData: EquipmentUnitDataVSICrusher | null;
}
